import { render, staticRenderFns } from "./GroupTable.vue?vue&type=template&id=77246e68&"
import script from "./GroupTable.vue?vue&type=script&lang=js&"
export * from "./GroupTable.vue?vue&type=script&lang=js&"
import style0 from "./GroupTable.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports